import Axios from "axios";
import {
    SET_DOCUMENTS_RECENT_LIST,
    UNSET_DOCUMENTS_RECENT_LIST,
} from "@/store/mutation-types";

import { 
    getRecentDocumentsList,
} from "@/store/api";

const state = {
    getRecentDocumentsList: [],
};

const getters = {
    getRecentDocumentsList(state) {
        return state.getRecentDocumentsList;
    },
};

const mutations = {
    [SET_DOCUMENTS_RECENT_LIST](state, data) {
        state.getRecentDocumentsList = data;
    },
    [UNSET_DOCUMENTS_RECENT_LIST](state) {
        state.getRecentDocumentsList = [];
    },
};

const actions = {
    getRecentDocumentsList({ commit }, data) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", {color: "primary"});
            Axios.get(getRecentDocumentsList, { params: data})
                .then(function (response) {
                    commit('SET_DOCUMENTS_RECENT_LIST', response.data.data)
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_DOCUMENTS_RECENT_LIST')
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING")
                });
        });
    },

};

export default {
    state,
    getters,
    actions,
    mutations,
};
